export const LayoutFilters = {
    SET_LAYOUT_OPTIONS: 'IN_MEMORY.LAYOUT.SET_LAYOUT_OPTIONS',
};

export const setLayoutOptions = options => ({
    type: LayoutFilters.SET_LAYOUT_OPTIONS,
    options
});